import {
  WSElement,
  WSModalProvider,
  WSProvider,
  WSSnackbarProvider,
  WSText
} from "@wingspanhq/fe-component-library";
import "@wingspanhq/fe-component-library/dist/style.css";
import queryString from "query-string";
import React, { useState } from "react";
import { ReactQueryDevtools } from "react-query-devtools";
import { Route, Router, Switch } from "react-router-dom";
import "../../global.scss";
import { CreateTestInvoice } from "../../screens/CreateTestInvoice";
import { CreateTestUser } from "../../screens/CreateTestUser";
import { SignInTestUser } from "../../screens/SignInTestUser";
import { SignOut } from "../../screens/SignOut";
import "../../services/payments";
import { pushSessionToken } from "../../services/sessionStorage";
import "../../services/users";
import { wsStore } from "../../store";
import { history } from "../../store/history";
import { WSStoreProvider } from "../../utils/WSStore";
import { CaptchaProvider } from "../Captcha";
import { Notifications } from "../Notification/Notification";
import { Main } from "./Main";
import { Onboarder } from "../../Onboarder/Onboarder";

export const IS_DEV_ENV =
  process.env.REACT_APP_ENV === "local" ||
  process.env.REACT_APP_ENV === "dev" ||
  process.env.REACT_APP_ENV === "staging";

export const IS_PRODUCTION_ENV = !IS_DEV_ENV;

const App: React.FC = () => {
  const [hideDevTools, setHideDevTools] = useState(false);

  const buildEnv = process.env.REACT_APP_ENV;
  const buildTarget = process.env.REACT_APP_BUILD_TARGET || "app";
  const buildDate = new Date(
    `${process.env.REACT_APP_BUILD_TIMESTAMP}`
  ).toLocaleString(undefined, { hour12: false });
  const buildCommit = process.env.REACT_APP_GIT_LATEST_COMMIT;
  const queries = queryString.parse(window.location.search);
  if (
    [
      "/member/authorize/verification/email/confirm",
      "/member/authorize/2fa/email/confirm"
    ].includes(window.location.pathname) &&
    queries.token
  ) {
    pushSessionToken(queries.token as string);
  }

  return (
    <>
      <WSProvider>
        <WSModalProvider>
          <WSSnackbarProvider>
            <Router history={history}>
              <WSStoreProvider store={wsStore}>
                <CaptchaProvider>
                  {buildTarget === "app" ? (
                    <Switch>
                      {IS_DEV_ENV ? (
                        <Route
                          path="/create-test-user"
                          exact
                          component={CreateTestUser}
                        />
                      ) : null}
                      {IS_DEV_ENV ? (
                        <Route
                          path="/sign-in-test-user"
                          exact
                          component={SignInTestUser}
                        />
                      ) : null}
                      {IS_DEV_ENV ? (
                        <Route
                          path="/create-test-invoice"
                          exact
                          component={CreateTestInvoice}
                        />
                      ) : null}
                      <Route
                        path={["/sign-out", "/signout", "/log-out", "/logout"]}
                        exact
                        component={SignOut}
                      />
                      <Route
                        render={() => (
                          <>
                            <Notifications />
                            <Main />
                          </>
                        )}
                      />
                    </Switch>
                  ) : buildTarget === "onboarder" ? (
                    <Onboarder />
                  ) : (
                    <WSText>
                      Don't know build target {JSON.stringify(buildTarget)}...
                      whatcha trying to do?
                    </WSText>
                  )}
                </CaptchaProvider>
              </WSStoreProvider>
            </Router>
          </WSSnackbarProvider>
        </WSModalProvider>
      </WSProvider>
      {IS_DEV_ENV && !hideDevTools && (
        <>
          <ReactQueryDevtools initialIsOpen={false} />
          <WSElement
            style={{
              position: "fixed",
              bottom: "2px",
              width: "100%",
              textAlign: "center"
            }}
          >
            <WSText.LabelExtraSmall
              color="grey500"
              onClick={() => setHideDevTools(true)}
            >
              build: {buildEnv} | updated: {buildDate} | hash: {buildCommit}
            </WSText.LabelExtraSmall>
          </WSElement>
        </>
      )}
    </>
  );
};

export default App;
